export default __webpack_public_path__ + "static/media/footprint.cd24750b.svg";